import React, {Component} from "react";
import {Table} from "reactstrap";
import AddApp from "./AddApp";
import ConfirmDialog from "../../common/ConfirmDialog/ConfirmDialog";
import Loading from "../../common/Loading/Loading";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {sortBy} from "../../utils";
import "./UserApps.css";
import Permissions from "../../authentication/Permissions";
import AuthorizationService from "../../services/authorization-service";
import AddButton from "../../common/AddButton/AddButton";

class UserApps extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isDeleteProductModalVisible: false,
            updateProduct: {},
            productToRemove: "",
        };
    }

    saveUser = async (appMeta) => {
        this.props.updateUser(appMeta)
    }

    removeProduct = () => {
        let meta = {
            appMetaData: {
                action: "remove",
                product: this.state.productToRemove,
                tenant: this.state.tenantToRemove
            }
        }
        this.props.updateUser(meta)
        this.setState({
            isDeleteProductModalVisible: false
        })
    }

    renderApps = () => {
        const allProducts = [];
        const permissions = {...this.props.user.appMetaData.permissions};

        Object.keys(permissions).forEach((app) => {
            const product = permissions[app];
            //If we don't have roles at this level, than we have tenants
            if (!product.hasOwnProperty("roles")) {
                Object.keys(product).forEach((tenant) => {
                    let localPerms = product[tenant];
                    localPerms.name = app;
                    localPerms.tenant = tenant;
                    allProducts.push(localPerms);
                });
            } else {
                product.name = app;
                allProducts.push(product);
            }
        });

        return sortBy(allProducts, "name")
            .map((product, i) => this.renderProducts(product, i));
    };

    getAttributes(product) {
        let keys = Object.keys(product)
        keys = keys.filter(k => !["roles", "name", "environments"].includes(k))
        if (keys.length > 0) {
            return keys.map(k => k + ":" + product[k]).join(", ")
        }
        return "No Attributes"
    }

    renderProducts = (product, i) => {
        return (
            <tr key={`${i}`}>
                <td className="width-20">
                    {product.name ? product.name : "N/A"}
                </td>
                <td className="width-20">
                    {product.tenant ? product.tenant : "N/A"}
                </td>
                <td className="width-20">
                    {product.roles && product.roles.length > 0 ? product.roles.join(", ") : "No Roles"}
                </td>
                <td className="width-20">
                    {product.environments && product.environments.length > 0 ? product.environments.join(", ") : "No Environment"}
                </td>
                <td className="width-20">
                    {this.getAttributes(product)}
                </td>
                <td className="width-5">
                    {AuthorizationService.hasPermission(Permissions.user.edit) &&
                    <span>
                    <FontAwesomeIcon
                        className="far edit-icon"
                        icon="edit"
                        size="lg"
                        color="#59595B"
                        onClick={() =>
                            this.setState({
                                isEdit: true,
                                updateProduct: product
                            })
                        }
                    />
                    <AddApp
                        toggleState={this.state.updateProduct.name === product.name}
                        cancelAction={() => this.setState({updateProduct: {}})}
                        isEdit={true}
                        updateProduct={product}
                        saveAction={this.saveUser}
                        user={this.props.user}
                    />
                    </span>
                    }

                </td>
                <td className="width-5 delete">
                    {AuthorizationService.hasPermission(Permissions.user.edit) &&

                    <FontAwesomeIcon
                        className="far delete-icon"
                        icon="times"
                        size="sm"
                        color="#59595B"
                        onClick={() =>
                            this.setState({
                                isDeleteProductModalVisible: true,
                                productToRemove: product.name,
                                tenantToRemove: product.tenant
                            })
                        }
                    />

                    }
                </td>
            </tr>
        );
    };


    render() {

        return (
            <div className="user-apps">
                {AuthorizationService.hasPermission(Permissions.user.add) &&
                <AddButton
                    name="Add Product"
                    handleCreateDialogToggle={() => {
                        this.setState({
                            isAddProductModalVisible: true,
                            isEdit: false
                        })
                    }}
                    className="btn-add-key"
                />
                }


                <Table>
                    <thead>
                    <tr>
                        <th className="width-20">Product</th>
                        <th className="width-10">Tenant</th>
                        <th className="width-20">Roles</th>
                        <th className="width-20">Environments</th>
                        <th className="width-20">Attributes</th>
                        <th className="width-5">Edit</th>
                        <th className="width-5">Remove</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.state.loading ? (
                        <tr>
                            <td>
                                <Loading/>
                            </td>
                        </tr>
                    ) : (
                        this.renderApps()
                    )}
                    </tbody>
                </Table>
                <AddApp
                    toggleState={this.state.isAddProductModalVisible}
                    cancelAction={() => this.setState({isAddProductModalVisible: false})}
                    isEdit={false}
                    updateProduct={{}}
                    saveAction={this.saveUser}
                    user={this.props.user}
                />
                {/* Delete app */}
                <ConfirmDialog
                    toggleState={this.state.isDeleteProductModalVisible}
                    cancelAction={() => this.setState({isDeleteProductModalVisible: false})}
                    message={`Remove ${
                        this.state.productToRemove
                    } access for ${this.props.user.firstName} ${this.props.user.lastName}?`}
                    confirmAction={() => this.removeProduct()}
                    confirmActionName="Remove"
                    confirmClassName={"btn-warning"}
                    caption="Remove App Access"
                    isLoading={this.state.isDialogLoading}
                />
            </div>
        );
    }
}

export default UserApps;





// WEBPACK FOOTER //
// ./src/user-profile/components/UserApps.js